module.exports = __webpack_public_path__ + "media/hyper/images/projects/project-3-d19a28ee658d966267252ce848824cf4.jpg";